export default __webpack_public_path__ + "static/media/t4.b3afd9c1.png";